document.addEventListener('DOMContentLoaded', function () {
  const list = document.querySelector('.multicolumn-list');
  
  if (!list) {
    console.error('Element with class multicolumn-list not found.');
    return;
  }

  const items = list.querySelectorAll('li');
  const loadMoreButton = document.getElementById('load-more');
  let currentIndex = 6;

  // 初期表示：最初の6個のみ表示
  function initializeItems() {
    items.forEach((item, index) => {
      if (index >= currentIndex) {
        item.style.display = 'none';
      }
    });
    if (items.length > currentIndex) {
      loadMoreButton.style.display = 'block';
    }
  }

  // 「さらに読み込む」ボタンがクリックされたときの処理
  loadMoreButton.addEventListener('click', function () {
    let nextIndex = currentIndex + 6;
    for (let i = currentIndex; i < nextIndex && i < items.length; i++) {
      items[i].style.display = 'block';
    }
    currentIndex = nextIndex;
    if (currentIndex >= items.length) {
      loadMoreButton.style.display = 'none';
    }
  });

  initializeItems();
});
